import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Message from "@components/Message";

import { OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";

type TPhoneNotificationMessageProps = {
  phoneCountryCode: string | null | undefined;
};
const ReceiverPhoneNotificationMessage: FC<TPhoneNotificationMessageProps> = ({ phoneCountryCode }) => {
  const { t } = useTranslation();
  const {
    values: { [OrderFields.DESTINATION_COUNTRY]: selectedCountry },
  } = useOrderFormik();

  if (phoneCountryCode === null || phoneCountryCode === undefined || phoneCountryCode === selectedCountry) {
    return null;
  }

  return (
    <Message align="start" icon={<Icon icon="info" size="1.25rem" />} sx={{ py: "0.7rem" }}>
      <Box>{t("order-receiver-phone_dont_match_receiver_country")}</Box>
    </Message>
  );
};
export default ReceiverPhoneNotificationMessage;
